import styled from 'styled-components'

const MAX_WIDTH_PX = 1396 // Consistent with max width of OrderRequestView

export const DiscoverMoreViewStyled = styled.div`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.typography.pxToRem(MAX_WIDTH_PX)};
`
